<template>
  <div>
    <button
      class="button"
      :class="{ 'is-primary': primary, 'is-fullwidth': wide }"
      :disabled="disabled"
      @click="resetPassword"
    >
      {{ label }}
    </button>
    <p v-if="error" class="help is-danger">{{ error }}</p>
    <p v-if="message" class="help">{{ message }}</p>
  </div>
</template>

<script>
import { actions } from "@/store"

export default {
  name: "reset-password-button",
  props: ["label", "email", "disabled", "primary", "wide"],
  data() {
    return {
      error: undefined,
      message: undefined
    }
  },
  methods: {
    resetPassword() {
      actions.clearErrors()
      this.error = undefined
      this.message = undefined
      actions
        .sendResetPasswordEmail(this.email)
        .then(() => {
          this.message = this.$t("Password reset e-mail sent.")
        })
        .catch(error => {
          if (error.code === "auth/user-not-found") {
            this.error = this.$t(error.code)
            this.$logger.error("user-not-found", error)
          } else {
            this.error = this.$t("reset-password-error")
            this.$logger.error("reset-password-error", error)
          }
        })
    }
  }
}
</script>
